<div *ngIf="formGroup && control && formControlName">
    <h3 *ngIf="header" [id]="headerId">{{ header }}</h3>
    <h4 *ngIf="label" [id]="labelId">{{ label }}{{ required ? " *" : "" }}</h4>
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
        <div
            fxFlex="100"
            fxLayoutAlign="start center"
            fxFlex.xs="100"
            fxFlexFill
        >
            <span
                class="radio-checkbox-group"
                fxFlex="100"
                role="group"
                [attr.aria-labelledby]="activeHeadingId"
            >
                <ul role="presentation">
                    <li *ngFor="let selection of selections">
                        <mat-checkbox
                            *ngIf="control"
                            [value]="selection.selectionId.toString()"
                            [checked]="_value.includes(selection.selectionId)"
                            color="primary"
                            (change)="updateCheckboxGroup($event)"
                        >
                            <span class="wrap-mat-radio-checkbox-label">{{
                                selection.label
                            }}</span>
                        </mat-checkbox>
                    </li>
                </ul>
                <mat-error
                    *ngIf="
                        ((control && control.touched) || formSubmitted) &&
                        hasRequiredError
                    "
                    >{{ requiredMessage }}
                </mat-error>
            </span>
        </div>
    </div>
</div>
